import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
const cn = {
  message: {
    login: '登录',
    register: '注册',
    forgetPwd: '忘记密码',
    getVerificationCode: '获取验证码',
    createExm: '创建考试',
    inputPwd: '请输入密码',
    examAnnouncemen: "考试公告",
    more: "更多",
    announcemen: "公告",
    switchLanguage: "确定切换语言吗?",
    releaseTime: "发布时间",
    reSend: "重新发送",
    read: "已阅读",
    prev: "上一条",
    next: "下一条"
  },
  sidebar: {
    myApplication: '我的报考',
    myAppointment: '我的预约',
    myExemption: '我的免试',
    myInvoice: '我的发票',
    personalInformation: '个人信息',
    accountSecurity: '账户安全',
    helpCenter: '帮助中心',
    freeCommitment: "免试承诺书",
    selectBatch: "选择批次",
  },
  header: {
    home: '首页',
    registrationExam: '报名考试',
    registrationXjncxys: '报名',
    appointmentTestSite: '预约考点',
    exemptionApplication: '免试申请',
    admissionTicketPrinting: '准考证打印',
    resultInquiry: '成绩查询',
    noticeAnnouncemen: "通知公告",
  },
  common: {
    nextStep: "下一步",
    tip: "提示",
    confirm: "确定",
    enterCode: "请输入验证码",
    remark: "备注",
    operation:"操作",
    cancel:"取消"
  },
  login: {
    accountLogin: "用户登录",
    phoneLogin: "手机快速登录",
    findPwd: "找回密码",
    register: "马上注册",
    login: "登录",
    idNumber: "证件号码",
    pwd: "密码",
    verificationCode: "验证码",
    phoneNum: "手机号",
    phoneCode: "手机验证码",
    emailCode: "邮箱验证码",
    welcome: "欢迎您",
    signOut: "退出"
  },
  register: {
    regTitle: "用户注册/认证",
    accVerification: "账号验证",
    improveInformation: "完善账号信息",
    success: "成功",
    selectMethod: "请选择验证方式",
    phoneVerification: "手机验证",
    emailVerification: "邮箱验证",
    existingAccount: "已有账号",
    logIn: "马上登录",
    email: "邮箱",
    fillRealName: "请填写证件上的真实姓名",
    IDType: "证件类型",
    fillIDNumber: "请填写证件号,注册完成无法修改",
    loginPwd: "登录密码",
    confirmPwd: "确认密码",
    agree: "同意",
    manmal: "用户手册",
    regcomplete: "注册完成",
    successTip1: "您可使用注册时填写的手机号或证件号完成登录。",
    successTip2: "您的信息发生变更后，请及时登录平台更新个人信息。",
    successTip3: "请确保账号安全，忘记密码可使用已绑定手机号或邮箱找回。",
    back: "返回首页",
    enterPhoneNum: "请输入手机号",
    worngPhoneNum: "手机号错误，请输入正确号码",
    worngEmail: "邮箱格式错误，请输入正确邮箱",
    phoneRegistered: "该手机号已被注册，可直接登录",
    emailRegistered: "该邮箱已被注册，可直接登录",
    enterEmail: "请输入邮箱",
    enterAccount: "请输入6-26字母+数字，首位必须为字母",
    accRegistered: "该账号已被占用，请重新输入",
    pwdlimit: "请输入6-26位数字、字母或特殊字符",
    confirmPwdAgain: "请再次确认密码",
    confirmPwdWrong: "确认密码输入有误，请重新输入!",
    wrongId: "证件号码错误，请输入正确证件号",
    selectIdType: "请选择一项证件类型!",
    idRegistered: "证件号码已经被注册",
    enterName: "请输入姓名",
    agreeManual: "请阅读并同意ATA用户手册",
  },
  findPwd: {
    retrievePwd: "找回密码",
    phoneReset: "手机重置",
    emailReset: "邮箱重置",
    confirmChangePwd: "确认修改密码",
    noBindPhone: "该手机号无绑定用户，请重新输入",
    noBindEmail: "该邮箱无绑定用户，请重新输入",
    changePwdSuccess: "修改密码成功"
  },
  examRegisteation: {
    closeTip: "报名暂未开放，暂时不能进行报考操作。",
    batchName: "批次名称",
    ExamTime: "考试时间",

  },
  print: {
    payAttention:"准考证打印暂未开放，请关注报考通知，以便及时了解准考证打印开放时间。",
    begin_time:"准考证打印暂未开放，开放时间",
    to:"至",
    takeTheExam:"，参加考试时需持报名时的身份证件和准考证参加考试。",
    suspendPrint:"准考证打印已暂停，请关注考试公告，以便了解准考证打印开放时间。",
    print:"打印",
    noPrintable:"暂时没有可打印的准考证。",
    ExamSiteMap:"考点地图",
    nothing:"无",
  },
  grade: {
    gradeQuery: "成绩查询暂未开放"
  },
  ...zhLocale
}

export default cn